export default __webpack_public_path__ + "images/pointer-green.0c32b228cfc5bd438e383a70c36aa91b.png";